import clsx from 'clsx'
import { buildGradientStyle } from '@utils/buildGradientStyle'
import { buildGradientBorderStyle } from '@utils/buildGradientBorderStyle'
import toggleCircle from '@assets/buy-bonus/toggle-circle.svg'

interface ToggleButtonProps {
    isToggled: boolean
    onClick: () => void
    toggleBackgroundColors?: string[]
    disabled?: boolean
}

const ToggleButton = ({ onClick, toggleBackgroundColors = ['#2E2E2E'], isToggled, disabled }: ToggleButtonProps) => {
    const handleToggle = () => {
        onClick()
    }

    const togglePositionClasses = clsx(
        'absolute top-[6px] left-[6px] transition-transform duration-200',
        isToggled && 'translate-x-[64px]'
    )

    const toggleBgStyle = buildGradientStyle(isToggled ? ['#306611', '#52AF1C'] : toggleBackgroundColors)
    const guaranteedWinBorderStyles = buildGradientBorderStyle(['#FFA146', '#FFF089', '#FFA146'], 2, 50)

    return (
        <div
            style={{
                ...guaranteedWinBorderStyles,
                ...(disabled && { opacity: 0.5, pointerEvents: 'none' }),
                width: '130px',
            }}
            className="box-border rounded-[50px] transition-all bg-gradient-to-r duration-450 cursor-pointer"
        >
            <div style={toggleBgStyle} className="relative w-[126px] h-[62px] rounded-[50px]" onClick={handleToggle}>
                <img src={toggleCircle} className={togglePositionClasses} alt="Toggle Button" />
            </div>
        </div>
    )
}

export default ToggleButton
